<ng-container *flexyooLet="notificationsCount$ | async as notificationsCount">
  @if (notificationsCount !== null && notificationsCount !== undefined) {
    <span
      *flexyooLet="isSilentModeOn$ | async as isSilentModeOn"
      class="notifications-dropdown-trigger"
    >
      <button
        class="notifications-button"
        matIconButton
        (click)="toggleNotificationsSidebar()"
      >
        <mat-icon
          class="notifications-button-icon"
          [svgIcon]="isSilentModeOn ? 'fo-bell-off' : 'fo-bell'"
        ></mat-icon>
      </button>
      @if (notificationsCount && !isSilentModeOn) {
        <span class="notifications-count">
          {{ notificationsCount }}
        </span>
      }
    </span>
  }
</ng-container>
